const COMPOSER_NUMBER_FORMAT = new Intl.NumberFormat('en-US', {
  useGrouping: false,
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

/** Display-only formatting; the authored number is never rounded or replaced. */
export function formatComposerNumber(value: number): string {
  return COMPOSER_NUMBER_FORMAT.format(value);
}
